import { render, staticRenderFns } from "./FullScreenUploadedDocumentViewer.vue?vue&type=template&id=4981ecda"
import script from "./FullScreenUploadedDocumentViewer.vue?vue&type=script&lang=js"
export * from "./FullScreenUploadedDocumentViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports